import { Component, OnInit } from '@angular/core';
import { first, map } from 'rxjs/operators';
import { DbService } from 'src/app/core/services/db.service';

@Component({
  selector: 'app-show-privacy',
  templateUrl: './show-privacy.component.html',
  styleUrls: ['./show-privacy.component.scss'],
})
export class ShowPrivacyComponent implements OnInit {
  privacy: string;

  constructor(private db: DbService) {}

  async ngOnInit(): Promise<void> {
    this.privacy = await this.getAdmin();
  }

  getAdmin(): Promise<any> {
    return this.db
      .doc$(`appService/HBJIDSBsZtIpe00tWiD5`)
      .pipe(
        map(data => {
          return data.privacyAreement;
        })
      )
      .pipe(first())
      .toPromise();
  }
}
